// extracted by mini-css-extract-plugin
module.exports = {"acceptanceCriteria":"styles_acceptanceCriteria__BKJEz"};